module.exports = __webpack_public_path__ + "img/titlevi.dd1a5191.png";